import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

import ongoingCareIcon from '@/assets/explore-maatra/ongoing-care.png';
import remoteFamilyIcon from '@/assets/explore-maatra/remote-family.png';
import scatteredHealthIcon from '@/assets/explore-maatra/scattered-health.png';
import hospitalisationIcon from '@/assets/explore-maatra/hospitalisation.png';
import blobBg from '@/assets/explore-maatra/blob-bg.svg';

import styles from './WhatCanMaatraDo.module.css';

const CARDS = [
  {
    key: 'ongoingCare',
    icon: ongoingCareIcon,
    gradient: 'linear-gradient(98.96deg, #FEF3E6 0.4%, #FDE5EB 99.36%)',
    route: '/explore-maatra/ongoing-care',
  },
  {
    key: 'remoteFamily',
    icon: remoteFamilyIcon,
    gradient: 'linear-gradient(98.96deg, #E7F5EF 0.4%, #F4EBFE 99.36%)',
    route: '/explore-maatra/remote-family',
  },
  {
    key: 'scatteredHealth',
    icon: scatteredHealthIcon,
    gradient: 'linear-gradient(98.96deg, #FDF9F1 0.4%, #F6EBFF 99.36%)',
    route: '/explore-maatra/scattered-records',
  },
  {
    key: 'hospitalisation',
    icon: hospitalisationIcon,
    gradient: 'linear-gradient(98.96deg, #F4E9FF 0.4%, #FCE3ED 99.36%)',
    route: '/explore-maatra/hospitalisation',
  },
] as const;

const WhatCanMaatraDo: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      {/* Purple blob background */}
      <div className={styles.blob}>
        <img src={blobBg} alt="" aria-hidden />
      </div>

      {/* Back header */}
      <div className={styles.header}>
        <button type="button" className={styles.backButton} onClick={() => navigate(-1)}>
          <IconChevronLeft size={16} stroke={2.5} />
          <span>{t('auth.exploreMaatra.back')}</span>
        </button>
      </div>

      {/* Hero text */}
      <div className={styles.heroContent}>
        <p className={styles.subtitle}>{t('auth.exploreMaatra.subtitle')}</p>
        <h1 className={styles.heading}>
          {t('auth.exploreMaatra.heading').split('\n').map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i === 0 && <br />}
            </React.Fragment>
          ))}
        </h1>
      </div>

      {/* Bottom section: card list */}
      <div className={styles.bottomSection}>
        <p className={styles.cardSubtitle}>{t('auth.exploreMaatra.cardSubtitle')}</p>
        <div className={styles.cardList}>
          {CARDS.map(({ key, icon, gradient, route }) => (
            <div
              key={key}
              className={styles.card}
              style={{ background: gradient }}
              onClick={() => route && navigate(route)}
            >
              <div className={styles.cardLeft}>
                <div className={styles.iconWrapper}>
                  <img src={icon} alt="" className={styles.icon} />
                </div>
                <span className={styles.cardLabel}>
                  {t(`auth.exploreMaatra.cards.${key}`)}
                </span>
              </div>
              <div className={styles.chevronWrapper}>
                <IconChevronRight size={24} stroke={2} color="#2a0d55" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatCanMaatraDo;
